export default __webpack_public_path__ + "static/media/postcard_landscape_6x4in.621577c4.png";